import { edpApiV1 } from '../index';
import {
  CreateSubstiutionRequest,
  GetAllDivisionsRequest,
  GetAllDivisionsResponse,
  GetAllSubstitutionsRequest,
  GetAllSubstitutionsResponse,
  GetEmployeesRequest,
  GetEmployeesResponse,
  GetEmployeesVacationsResponse,
  GetSingleSubstitutionResponse,
  GetSubstitutionChangesHistoryResponse,
  UpdateSubstiutionRequest,
} from './types';

export const substitutionsApi = edpApiV1.injectEndpoints({
  endpoints: build => ({
    getAllDivisions: build.query<GetAllDivisionsResponse, GetAllDivisionsRequest>({
      query: payload => ({ url: '/v1/admin/substitution/divisions', method: 'GET', params: payload }),
      providesTags: ['substitutions'],
    }),
    getAllDivisionsForAddSubstitution: build.query<GetAllDivisionsResponse, GetAllDivisionsRequest>({
      query: payload => ({ url: '/v1/admin/substitution/divisions', method: 'GET', params: payload }),
      providesTags: ['substitutions-add'],
    }),
    getAllSubstitutions: build.query<GetAllSubstitutionsResponse, GetAllSubstitutionsRequest>({
      query: payload => ({ url: '/v1/admin/substitution/requests', method: 'GET', params: payload }),
      providesTags: ['substitutions'],
    }),
    getSingleSubstitution: build.query<GetSingleSubstitutionResponse, string>({
      query: id => ({ url: `/v1/admin/substitution/requests/${id}`, method: 'GET' }),
      providesTags: ['singleSubstitution'],
    }),
    createSubstitution: build.mutation<{ id: number }, CreateSubstiutionRequest>({
      query: body => ({ url: '/v1/admin/substitution/requests', method: 'POST', body }),
      invalidatesTags: ['substitutions'],
    }),
    updateSubstitution: build.mutation<{ id: number }, UpdateSubstiutionRequest>({
      query: ({ requestId, ...body }) => ({
        url: `/v1/admin/substitution/requests/${requestId}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['substitutions'],
    }),
    deleteSubstitution: build.mutation<{ id: number }, string>({
      query: requestId => ({ url: `/v1/admin/substitution/requests/${requestId}`, method: 'DELETE' }),
      invalidatesTags: ['substitutions'],
    }),
    getSubstitutionChangesHistory: build.query<GetSubstitutionChangesHistoryResponse, string>({
      query: id => ({ url: `/v1/admin/substitution/requests/${id}/changes`, method: 'GET' }),
    }),
    getEmployeesForSubstitution: build.query<GetEmployeesResponse, GetEmployeesRequest>({
      query: payload => ({ url: '/v1/admin/substitution/employees', method: 'GET', params: payload }),
    }),
    getEmployeesVacations: build.query<GetEmployeesVacationsResponse, string>({
      query: employeeId => ({ url: `/v1/admin/substitution/employees/${employeeId}/vacations`, method: 'GET' }),
    }),
    downloadTimekeeperFile: build.query<string, void>({
      query: () => ({
        url: '/v1/admin/substitution/timekeepers/download-file',
        method: 'GET',

        responseHandler: async response => {
          const link = document.createElement('a');
          link.download = 'absence';
          link.href = window.URL.createObjectURL(await response.blob());
          link.click();
        },
      }),
      providesTags: ['substitutionsDownloanFile'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAllDivisionsQuery,
  useLazyGetAllDivisionsQuery,
  useGetAllDivisionsForAddSubstitutionQuery,
  useLazyGetAllDivisionsForAddSubstitutionQuery,
  useGetAllSubstitutionsQuery,
  useLazyGetAllSubstitutionsQuery,
  useGetSingleSubstitutionQuery,
  useLazyGetSingleSubstitutionQuery,
  useGetSubstitutionChangesHistoryQuery,
  useGetEmployeesForSubstitutionQuery,
  useLazyGetEmployeesForSubstitutionQuery,
  useCreateSubstitutionMutation,
  useDeleteSubstitutionMutation,
  useUpdateSubstitutionMutation,
  useGetEmployeesVacationsQuery,
  useLazyGetEmployeesVacationsQuery,
  useLazyDownloadTimekeeperFileQuery,
} = substitutionsApi;
